import { apiService } from './apiService';

// Cart API endpoints
export const cartApi = {
    // Get user's cart
    getCart: async (params?: Record<string, any>) => {
        return await apiService.get('/cart', { params });
    },

    // Add item to cart
    addToCart: async (itemData: any) => {
        return await apiService.post('/cart/add', itemData);
    },

    // Update cart item quantity
    updateCartItem: async (itemId: string, itemData: any) => {
        try {
            return await apiService.put(`/cart/items/${itemId}`, itemData);
        } catch (error) {
            throw error;
        }
    },

    // Remove item from cart
    removeCartItem: async (itemId: string) => {
        try {
            return await apiService.delete(`/cart/items/${itemId}`);
        } catch (error) {
            throw error;
        }
    },

    // Clear entire cart
    clearCart: async () => {
        try {
            return await apiService.delete('/cart/clear');
        } catch (error) {
            throw error;
        }
    },

    // Update cart add-ons
    updateCartAddOns: async (addOns: Array<{ name: string; price: number }>) => {
        try {
            return await apiService.put('/cart/addons', { addOns });
        } catch (error) {
            throw error;
        }
    },
};